export default class DashboardOffice {

	static selector = 'dashboard-office';

	el = {};

	constructor(container) {
		this.el = {
			container,
			ooo: document.querySelector(`.${this.constructor.selector}__ooo`)
		};

		gapi.load('client:auth2', () => {
			gapi.client.init({
				apiKey: 'AIzaSyB4ZbrdrnFDVfmSsmydHMsdv4kV4TzFjFI',
				clientId: '99938175929-n021ii5a57fhmsma6tfanl0jm296kqee.apps.googleusercontent.com',
				scope: 'https://www.googleapis.com/auth/calendar.readonly'
			}).then(() => {
				gapi.auth2.getAuthInstance().isSignedIn.listen(() => this.listEvents());
				if (!gapi.auth2.getAuthInstance().isSignedIn.get()) {
					gapi.auth2.getAuthInstance().signIn();
				} else {
					this.listEvents();
				}
			});
		});
	}

	listEvents() {
		gapi.client.load('https://content.googleapis.com/discovery/v1/apis/calendar/v3/rest').then(() => {
			gapi.client.calendar.calendarList.list({}).then((data) => {
				const locations = {
					'BASIC Agency-5-B1 - Break Room / Kitchen (40)': 'break-room',
					'BASIC Agency-5-C3 - Lounge (10)': 'lounge',
					'BASIC Agency-5-C4 - ThinkTank / Collab Room (4)': 'think-tank',
					'BASIC Agency-5-H1 - Huddle 1 (10)': 'huddle-1',
					'BASIC Agency-5-H2 - Huddle 2 (10)': 'huddle-2',
					'BASIC Agency-5-H3 - Huddle 3 (10)': 'huddle-3',
					'BASIC Agency-5-C2 - White (4)': 'white',
					'BASIC Agency-5-C1 - Black (4)': 'black',
					'BASIC Agency-5-Ryan\'s office (4)': 'ryan',
					'BASIC Agency-5-O2 - Ashley\'s Office (4)': 'ashley',
					'BASIC Agency-5-O3 - Steve\'s Office (4)': 'steve',
					'BASIC Agency-5-O4 - Matt\'s Office (4)': 'matt',
				};
				// gapi.client.calendar.events.list({
				// 	calendarId: 'basicagency.com_v3ta86hauf0gu4jbabcpn44dpo@group.calendar.google.com',
				// 	timeMin: (new Date()).toISOString(),
				// 	showDeleted: false,
				// 	singleEvents: true,
				// 	maxResults: 10,
				// 	orderBy: 'startTime'
				// }).then((response) => {
				// 	for (const item of response.result.items) {
				// 		const start = new Date(item.start.date);
				// 		if (start.getTime() <= Date.now()) {
				// 			console.log(item.summary, new Date(item.end.date).toLocaleDateString());
				// 		}
				// 	}
				// });
				for (const item of data.result.items) {
					if (locations[item.summary]) {
						gapi.client.calendar.events.list({
							calendarId: item.id,
							timeMin: (new Date()).toISOString(),
							showDeleted: false,
							singleEvents: true,
							maxResults: 1,
							orderBy: 'startTime'
						}).then((response) => {
							if (response.result.items.length) {
								const start = new Date(response.result.items[0].start.dateTime);
								const end = new Date(response.result.items[0].end.dateTime);
								// console.log(item.summary, response.result.items[0].creator, start.toLocaleString(), end.toLocaleString());
								const li = document.querySelector(`[data-id="${locations[item.summary]}"]`);
								const span = li.querySelector('span');
								if (start.getDate() === new Date().getDate()) {
									if (start.getTime() < Date.now()) {
										li.classList.add('is-busy');
										span.innerText = end.toLocaleTimeString('en-US', { hour: 'numeric', hour12: true, minute: 'numeric' });
									} else {
										li.classList.remove('is-busy');
										span.innerText = start.toLocaleTimeString('en-US', { hour: 'numeric', hour12: true, minute: 'numeric' });
									}
								} else {
									li.classList.remove('is-busy');
									span.innerText = '';
								}
							}
						});
					}
				}
				setTimeout(() => {
					this.listEvents();
				}, 30000);
			});
		});
	}

	addEventListeners() {

	}

	removeEventListeners() {

	}

	destroy() {

	}

}
